(ns common.schema.entities.common
  (:require
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]))

(def team-members-field
  [:common/team-members
   {:field/data-type             :data.type/ref-multi
    :field/default-ord           1590
    :value-type                  :entity
    :field/entity-types          [:entity.type/account]
    :field/default-authorization {:access/read  :role/user
                                  :access/write :role/user}
    :field/default-visibility    {:editor           :editor.type/none
                                  :grid             :editor.type/multi-select
                                  :filter           :filter.type/select
                                  :field-visibility :in-use}
    :field/translations          {:en "Team members"}
    :field/option-filter-fn      option-filters/active-users
    :field/os-filter-terms-fn    (fn [_args]
                                   {"extras.active-user" true})}])

(def common-network-drive-field
  [:common/network-drive
   {:field/data-type             :data.type/text-url
    :field/default-visibility    {:editor           :editor.type/url
                                  :grid             :editor.type/url
                                  :filter           :filter.type/text
                                  :field-visibility :not-in-use}
    :field/default-authorization {:access/read  :role/user
                                  :access/write :role/user}
    :field/translations          {:en "Network drive"}}])

(def common-network-drives-field
  (su/text-edn-field :common/named-network-drives
                     "Network drives"
                     {:authorization            su/access-user-user
                      :default-field-visibility :not-in-use}))

(def common-folders-path
  (su/text-edn-field :common/folder-structure
                     "Folders"
                     {:authorization            su/access-user-user
                      :hidden-from-config?      true
                      :default-field-visibility :in-use}))

(def common-domain-field
  [:common/domain
   {:field/data-type                  :data.type/text-simple
    :field/default-visibility         {:editor           :editor.type/none
                                       :grid             :editor.type/text-simple
                                       :filter           :filter.type/text
                                       :field-visibility :in-use}
    :field/default-authorization      {:access/read  :role/guest-sell-side
                                       :access/write :role/system}
    :field/hidden-from-configuration? true
    :field/translations               {:en "Domain"}}])

(def common-owner-role
  (su/single-ref-field :common/owner-role
                       "Owner role"
                       [:entity.type/role]
                       {:authorization              su/access-system-zadmin
                        :hidden-from-configuration? true
                        :editor-type                :editor.type/none
                        :grid-type                  :editor.type/none
                        :filter-type                :filter.type/none
                        :not-importable?            true}))

(def common-owner
  (su/single-ref-field :common/owner
                       "Owner account"
                       [:entity.type/account]
                       {:authorization              su/access-user-user
                        :hidden-from-configuration? true
                        :editor-type                :editor.type/none
                        :grid-type                  :editor.type/none
                        :filter-type                :filter.type/none
                        :option-filter-fn           option-filters/active-users
                        :os-filter-terms-fn         (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})}))

(def attachment-schema
  (su/multi-ref-field :common/attachments "Documents" [:entity.type/attachment]
                      {:authorization            su/access-ssg-ssg
                       :default-field-visibility :in-use
                       :editor-type              :editor.type/none
                       :grid                     :editor.type/none
                       :filter                   :filter.type/known
                       :not-importable?          true}))

(def liabilities-schema
  (su/multi-ref-field :common/liabilities
                      "Liabilities"
                      [:entity.type/liability]
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use
                       :editor-type              :editor.type/none
                       :grid-type                :editor.type/none
                       :filter-type              :filter.type/boolean
                       :required-modules         [:module/liabilities]}))

(def schema
  (concat
   [[:db/id
     {:field/data-type                  :data.type/id
      :field/system-semantics           {:field.system/value-control  :field.value-control/system-only
                                         :field.system/clearability    :field.clearability/not-clearable-after-set
                                         :field.system/modifiability   :field.modifiability/system-only}
      :field/default-authorization      {:access/read      :role/none
                                         :access/write     :role/system}
      :field/default-visibility         {:editor :editor.type/none
                                         :grid   :editor.type/none
                                         :filter :filter.type/select
                                         :field-visibility :in-use-disabled}
      :field/not-importable?            true
      :field/hidden-from-configuration? true
      :field/translations               {:en "UUID"}
      :validation-spec                  number?
      :field/name                       "UUI"
      :ui/default-editor-type           :editor.type/none
      :ui/allowed-editor-types          #{}
      :ui/default-filter-type           :filter.type/number
      :ui/allowed-filter-types          #{:filter.type/number}}]

    [:entity/type
     {:field/data-type                  :data.type/keyword
      :field/system-semantics           {:field.system/value-control :field.value-control/system-only
                                         :field.system/nullability   :field.nullability/system-required
                                         :field.system/clearability   :field.clearability/not-clearable-after-set
                                         :field.system/modifiability  :field.modifiability/system-only}
      :field/system-required?           true
      :field/default-authorization      {:access/read  :role/none
                                         :access/write :role/system}
      :field/default-visibility         {:editor :editor.type/none
                                         :grid   :editor.type/none
                                         :filter :filter.type/none
                                         :field-visibility :in-use-disabled}
      :field/not-importable?            true
      :field/hidden-from-configuration? true
      :field/translations               {:en "Entity type"}
      :validation-spec                  keyword?
      :field/name                       "Entity type"
      :ui/default-editor-type           :editor.type/none
      :ui/allowed-editor-types          #{}
      :ui/default-filter-type           :filter.type/none
      :ui/allowed-filter-types          #{}}]

    [:common/tenant
     {:field/data-type                  :data.type/ref-single
      :field/system-semantics           {:field.system/value-control :field.value-control/system-only
                                         :field.system/nullability   :field.nullability/system-required
                                         :field.system/clearability   :field.clearability/not-clearable-after-set
                                         :field.system/modifiability  :field.modifiability/system-only}
      :field/system-required?           true
      :value-type                       :entity
      :field/entity-types               [:entity.type/tenant]
      :field/default-authorization      {:access/read  :role/none
                                         :access/write :role/system}
      :field/default-visibility         {:editor :editor.type/none
                                         :grid   :editor.type/none
                                         :filter :filter.type/none
                                         :field-visibility :in-use-disabled}
      :field/not-importable?            true
      :field/hidden-from-configuration? true
      :field/translations               {:en "Tenant"}
      :validation-spec                  number?
      :field/name                       "Tenant"
      :ui/default-editor-type           :editor.type/none
      :ui/allowed-editor-types          #{}
      :ui/default-filter-type           :filter.type/number
      :ui/allowed-filter-types          #{:filter.type/number}}]]
   (su/text-simple-field :common/migration-note "Migration note"
                         {:authorization              su/access-system-admin
                          :editor-type                :editor.type/none
                          :grid                       :editor.type/none
                          :filter                     :filter.type/none
                          :system-semantics           su/system-controlled-optional-field-semantics
                          :hidden-from-configuration? true})
   (su/boolean-field :common/disabled? "Deactivated" {:authorization              su/access-user-ssg
                                                      :default-field-visibility   :in-use-disabled
                                                      :editor                     :editor.type/none
                                                      :grid                       :editor.type/none
                                                      :filter                     :filter.type/boolean
                                                      :hidden-from-configuration? true
                                                      :not-importable?            true})
   (su/datetime-field :common/disabled-on "Disabled on" {:authorization              su/access-system-zadmin
                                                         :default-field-visibility   :in-use-disabled
                                                         :editor-type                :editor.type/none
                                                         :grid                       :editor.type/none
                                                         :system-semantics           su/system-controlled-optional-field-semantics
                                                         :not-importable?            true
                                                         :hidden-from-configuration? true})
   (su/datetime-field :common/created-on "Created on" {:authorization              su/access-user-ssg
                                                       :default-field-visibility   :in-use-disabled
                                                       :editor-type                :editor.type/none
                                                       :grid                       :editor.type/none
                                                       :filter                     :filter.type/date
                                                       :system-semantics           su/system-created-field-semantics
                                                       :system-required?           true
                                                       :hidden-from-configuration? true})
   (su/single-ref-field :common/created-by "Created by" [:entity.type/account] {:authorization              su/access-system-ssg
                                                                                :editor-type                :editor.type/none
                                                                                :grid                       :editor.type/none
                                                                                :default-field-visibility   :in-use-disabled
                                                                                :system-semantics           su/system-created-field-semantics
                                                                                :system-required?           true
                                                                                :hidden-from-configuration? true
                                                                                :not-importable?            true
                                                                                :live-update-paths          []
                                                                                :option-filter-fn           option-filters/users})
   (su/datetime-field :common/updated-on "Updated on" {:authorization              su/access-system-ssg
                                                       :editor-type                :editor.type/none
                                                       :default-field-visibility   :in-use-disabled
                                                       :system-semantics           su/system-updated-field-semantics
                                                       :system-required?           true
                                                       :hidden-from-configuration? true
                                                       :not-importable?            true})
   (su/single-ref-field :common/updated-by "Updated by" [:entity.type/account] {:authorization              su/access-system-ssg
                                                                                :editor-type                :editor.type/none
                                                                                :grid                       :editor.type/none
                                                                                :default-field-visibility   :in-use-disabled
                                                                                :system-semantics           su/system-updated-field-semantics
                                                                                :system-required?           true
                                                                                :hidden-from-configuration? true
                                                                                :not-importable?            true
                                                                                :live-update-paths          []
                                                                                :option-filter-fn           option-filters/users})
   (su/text-simple-field :common/updated-by-email "Updated by - email" {:authorization              su/access-system-ssg
                                                                        :editor-type                :editor.type/none
                                                                        :default-field-visibility   :in-use-disabled
                                                                        :system-semantics           su/system-controlled-optional-field-semantics
                                                                        :hidden-from-configuration? true
                                                                        :not-importable?            true})
   (su/keyword-field :common/update-source "Update source" nil {:authorization              su/access-system-system
                                                                :editor-type                :editor.type/none
                                                                :default-field-visibility   :in-use-disabled
                                                                :system-semantics           su/system-controlled-optional-field-semantics
                                                                :hidden-from-configuration? true
                                                                :not-importable?            true})
   (su/boolean-field :common/zap-sample? "Sample data" {:authorization              su/access-system-system
                                                        :system-semantics           su/system-controlled-optional-field-semantics
                                                        :not-importable?            true
                                                        :hidden-from-configuration? true})
   (su/text-simple-field :common/hubspot-id "HubSpot ID" {:authorization              su/access-zadmin-zadmin
                                                          :not-importable?            true
                                                          :hidden-from-configuration? true})
   (su/text-simple-field :common/external-id "External ID" {:default-field-visibility :not-in-use})
   (su/boolean-field :common/archived? "Archived" {:authorization              su/access-admin-ssg
                                                   :default-field-visibility   :in-use-disabled
                                                   :editor                     :editor.type/none
                                                   :grid                       :editor.type/none
                                                   :filter                     :filter.type/none
                                                   :not-importable?            true
                                                   :hidden-from-configuration? true})
   attachment-schema
   (su/multi-ref-field :common/related-entities "Related entities" [:entity.type/any] {:authorization              su/access-ssg-ssg
                                                                                       :editor-type                :editor.type/none
                                                                                       :grid                       :editor.type/none
                                                                                       :filter                     :filter.type/none
                                                                                       :hidden-from-configuration? true
                                                                                       :default-field-visibility :in-use-disabled})
   (su/single-ref-field :common/containing-entity "Containing entity" [:entity.type/any] {:authorization              su/access-user-ssg
                                                                                          :editor-type                :editor.type/none
                                                                                          :grid                       :editor.type/none
                                                                                          :filter                     :filter.type/none
                                                                                          :hidden-from-configuration? true
                                                                                          :not-importable?            true
                                                                                          :default-field-visibility   :in-use-disabled})
    ;; TODO: check authorization ??
   (su/numeric-field :common/ord "Custom ordering" {:authorization              su/access-user-user
                                                    :default-field-visibility   :in-use-disabled
                                                    :editor-type                :editor.type/none
                                                    :grid                       :editor.type/none
                                                    :filter                     :filter.type/none
                                                    :not-importable?            true
                                                    :hidden-from-configuration? true})
   (su/multi-ref-field :common/change-meta "Change metadata" [:entity.type/change-meta] {:authorization              su/access-system-ssg
                                                                                         :default-field-visibility   :in-use-disabled
                                                                                         :editor-type                :editor.type/none
                                                                                         :grid                       :editor.type/none
                                                                                         :filter                     :filter.type/none
                                                                                         :system-semantics           su/system-controlled-optional-field-semantics
                                                                                         :not-importable?            true
                                                                                         :hidden-from-configuration? true})
   (su/single-ref-field :common/insider-group "Insider group" [:entity.type/insider-group] {:authorization              su/access-user-user
                                                                                            :editor-type                :editor.type/none
                                                                                            :grid                       :editor.type/none
                                                                                            :filter                     :filter.type/select
                                                                                            :default-field-visibility   :in-use-disabled
                                                                                            :not-importable?            true
                                                                                            :hidden-from-configuration? true})

   (su/boolean-field :common/exclude-from-reporting? "Exclude from reporting"
                     {:authorization su/access-user-user
                      :editor        :editor.type/none})

   (su/keyword-multi-field :common/system-kws
                           "System keywords"
                           nil
                           {:authorization su/access-system-user
                            :editor-type   :editor.type/none
                            :system-semantics su/system-controlled-optional-field-semantics})))
